/**
 * ベース URL とパスを連結する
 *
 * ベース URL は環境ごとに設定され、末尾スラッシュの有無が揃っていない
 * （末尾スラッシュ付きだと `https://consumer.example.com//experiences/xxx` のように
 * スラッシュが二重になる）。環境変数側を揃えるのは環境ファイルの管理に依存するため、
 * 組み立て側で正規化する
 */
const joinUrl = (baseUrl: string, path: string) => {
  const base = baseUrl.replace(/\/+$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return base + normalizedPath;
};

/** consumer 側の URL を組み立てる */
const buildConsumerUrl = (path: string, consumerUrl: string) => joinUrl(consumerUrl, path);

export const buildConsumerExperienceDetailUrl = (slug: string, consumerUrl: string) => {
  return buildConsumerUrl('/experiences/' + slug, consumerUrl);
};

/**
 * Otonami 側の管理画面の URL を組み立てる
 *
 * Wabunka の管理画面は admin-wabunka.* という別ドメインで配信されるため、Otonami 側の画面へは
 * 相対パスでは辿り着けない。OTONAMI_ADMIN_URL は環境ごとに設定される
 */
export const buildOtonamiAdminUrl = (path: string, otonamiAdminUrl: string) => joinUrl(otonamiAdminUrl, path);
